// extracted by mini-css-extract-plugin
module.exports = {"main":"login_main__U2mcH","loginContainer":"login_loginContainer__PJWTS","header":"login_header__5TWRo","loginForm":"login_loginForm__QSvva","formGroup":"login_formGroup__caHhm"};